interface ICities {
  label: string;
  values: {
    code: number;
    letters: string[];
  }[];
}

interface IPlateCities {
  province: string;
  cities: ICities[];
}

export const plateCityList: IPlateCities[] = [
  {
    province: "آذربایجان شرقی",
    cities: [
      {
        label: "تبریز",
        values: [
          {
            code: 15,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 35,
            letters: ["س", "ل", "م", "ه", "ی"],
          },
        ],
      },
      {
        label: "مراغه",
        values: [
          {
            code: 25,
            letters: ["ب"],
          },
          {
            code: 35,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "مرند",
        values: [
          {
            code: 25,
            letters: ["ج"],
          },
          {
            code: 35,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "میانه",
        values: [
          {
            code: 25,
            letters: ["د"],
          },
          {
            code: 35,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "اهر",
        values: [
          {
            code: 25,
            letters: ["س"],
          },
          {
            code: 35,
            letters: ["و"],
          },
        ],
      },
      {
        label: "هوراند",
        values: [
          {
            code: 25,
            letters: ["س"],
          },
          {
            code: 35,
            letters: ["و"],
          },
        ],
      },
      {
        label: "سراب",
        values: [
          {
            code: 25,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "جلفا",
        values: [
          {
            code: 25,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "هشترود",
        values: [
          {
            code: 25,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "بناب",
        values: [
          {
            code: 25,
            letters: ["ل"],
          },
          {
            code: 35,
            letters: ["ج", "د"],
          },
        ],
      },
      {
        label: "بستان آباد",
        values: [
          {
            code: 25,
            letters: ["م"],
          },
        ],
      },
      {
        label: "شبستر",
        values: [
          {
            code: 25,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "کلیبر",
        values: [
          {
            code: 25,
            letters: ["و"],
          },
        ],
      },
      {
        label: "خدا آفرین",
        values: [
          {
            code: 25,
            letters: ["و"],
          },
        ],
      },
      {
        label: "هریس",
        values: [
          {
            code: 25,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "آذر شهر",
        values: [
          {
            code: 25,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "اسکو",
        values: [
          {
            code: 25,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "ورزقان",
        values: [
          {
            code: 35,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "عجب شیر",
        values: [
          {
            code: 35,
            letters: ["د"],
          },
        ],
      },
      {
        label: "چاراویماق",
        values: [
          {
            code: 35,
            letters: ["س"],
          },
        ],
      },
      {
        label: "ملکان",
        values: [
          {
            code: 35,
            letters: ["ص"],
          },
        ],
      },
    ],
  },
  {
    province: "آذربایجان غربی",
    cities: [
      {
        label: "ارومیه",
        values: [
          {
            code: 17,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
            ],
          },
        ],
      },
      {
        label: "خوی",
        values: [
          {
            code: 27,
            letters: ["ب"],
          },
          {
            code: 37,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "چایپاره",
        values: [
          {
            code: 27,
            letters: ["ب"],
          },
          {
            code: 37,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "مهاباد",
        values: [
          {
            code: 27,
            letters: ["ج"],
          },
          {
            code: 37,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "ماکو",
        values: [
          {
            code: 27,
            letters: ["د"],
          },
          {
            code: 37,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "پلدشت",
        values: [
          {
            code: 27,
            letters: ["د"],
          },
          {
            code: 37,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "شوط",
        values: [
          {
            code: 27,
            letters: ["د"],
          },
        ],
      },
      {
        label: "سلماس",
        values: [
          {
            code: 27,
            letters: ["س"],
          },
          {
            code: 37,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "نقده",
        values: [
          {
            code: 27,
            letters: ["ص"],
          },
          {
            code: 37,
            letters: ["د"],
          },
        ],
      },
      {
        label: "میاندوآب",
        values: [
          {
            code: 27,
            letters: ["ط"],
          },
          {
            code: 37,
            letters: ["ج", "ن"],
          },
        ],
      },
      {
        label: "تکاب",
        values: [
          {
            code: 27,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "شاهین دژ",
        values: [
          {
            code: 27,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "سردشت",
        values: [
          {
            code: 27,
            letters: ["م"],
          },
        ],
      },
      {
        label: "بوکان",
        values: [
          {
            code: 27,
            letters: ["ن"],
          },
          {
            code: 37,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "چالدران",
        values: [
          {
            code: 27,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "پیرانشهر",
        values: [
          {
            code: 27,
            letters: ["و"],
          },
        ],
      },
      {
        label: "اشنویه",
        values: [
          {
            code: 27,
            letters: ["ی"],
          },
        ],
      },
    ],
  },
  {
    province: "اردبیل",
    cities: [
      {
        label: "اردبیل",
        values: [
          {
            code: 91,
            letters: ["ب", "ج", "د", "م", "ه", "و", "ی"],
          },
        ],
      },
      {
        label: "پارس‌آباد",
        values: [
          {
            code: 91,
            letters: ["س", "م"],
          },
        ],
      },
      {
        label: "خلخال",
        values: [
          {
            code: 91,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "گرمی",
        values: [
          {
            code: 91,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "بیله‌سوار",
        values: [
          {
            code: 91,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "مشگین‌شهر",
        values: [
          {
            code: 91,
            letters: ["ل", "م", "و", "ی"],
          },
        ],
      },
      {
        label: "نیر",
        values: [
          {
            code: 91,
            letters: ["م"],
          },
        ],
      },
      {
        label: "کوثر",
        values: [
          {
            code: 91,
            letters: ["م", "و"],
          },
        ],
      },
      {
        label: "نمین",
        values: [
          {
            code: 91,
            letters: ["ن"],
          },
        ],
      },
    ],
  },
  {
    province: "اصفهان",
    cities: [
      {
        label: "اصفهان",
        values: [
          {
            code: 13,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 53,
            letters: ["ب", "ج", "د", "س", "ص", "ق", "ل", "و"],
          },
          {
            code: 67,
            letters: ["ب", "ج", "د", "س", "ط", "ل", "م", "ن", "و"],
          },
        ],
      },
      {
        label: "کاشان",
        values: [
          {
            code: 23,
            letters: ["ب"],
          },
          {
            code: 43,
            letters: ["و"],
          },
          {
            code: 53,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "نجف‌آباد",
        values: [
          {
            code: 23,
            letters: ["ج"],
          },
          {
            code: 53,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "شهرضا",
        values: [
          {
            code: 23,
            letters: ["د"],
          },
        ],
      },
      {
        label: "خمینی‌شهر",
        values: [
          {
            code: 23,
            letters: ["س"],
          },
          {
            code: 43,
            letters: ["ن"],
          },
          {
            code: 53,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "گلپایگان",
        values: [
          {
            code: 23,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "نطنز",
        values: [
          {
            code: 23,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "اردستان",
        values: [
          {
            code: 23,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "خوانسار",
        values: [
          {
            code: 23,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "نائین",
        values: [
          {
            code: 23,
            letters: ["م"],
          },
        ],
      },
      {
        label: "سمیرم",
        values: [
          {
            code: 23,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "فلاورجان",
        values: [
          {
            code: 23,
            letters: ["ه"],
          },
          {
            code: 43,
            letters: ["ی"],
          },
          {
            code: 67,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "فریدون شهر",
        values: [
          {
            code: 23,
            letters: ["و"],
          },
        ],
      },
      {
        label: "لنجان یا زرین شهر",
        values: [
          {
            code: 23,
            letters: ["ی"],
          },
          {
            code: 43,
            letters: ["ه"],
          },
          {
            code: 67,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "فریدن",
        values: [
          {
            code: 43,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "بوئین و میاندشت",
        values: [
          {
            code: 43,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "چادگان",
        values: [
          {
            code: 43,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "مبارکه",
        values: [
          {
            code: 43,
            letters: ["ج", "ط"],
          },
        ],
      },
      {
        label: "شاهین شهر و میمه",
        values: [
          {
            code: 43,
            letters: ["د", "ل"],
          },
          {
            code: 53,
            letters: ["م"],
          },
          {
            code: 67,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "آران و بیدگل",
        values: [
          {
            code: 43,
            letters: ["س"],
          },
        ],
      },
      {
        label: "تیران و کرون",
        values: [
          {
            code: 43,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "دهاقان",
        values: [
          {
            code: 43,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "نجف‌آباد",
        values: [
          {
            code: 43,
            letters: ["م"],
          },
        ],
      },
      {
        label: "شهرضا",
        values: [
          {
            code: 53,
            letters: ["ط"],
          },
        ],
      },
    ],
  },
  {
    province: "البرز",
    cities: [
      {
        label: "ساوجبلاغ",
        values: [
          {
            code: 21,
            letters: ["ص"],
          },
          {
            code: 78,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "نظرآباد",
        values: [
          {
            code: 78,
            letters: ["م"],
          },
        ],
      },
      {
        label: "هشتگرد",
        values: [
          {
            code: 78,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "طالقان",
        values: [
          {
            code: 78,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "کرج",
        values: [
          {
            code: 21,
            letters: ["ل", "و"],
          },
          {
            code: 30,
            letters: ["د", "س", "ل", "م", "ه"],
          },
          {
            code: 38,
            letters: ["د", "س", "ن", "م", "ی", "ب", "ه"],
          },
          {
            code: 68,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
        ],
      },
    ],
  },
  {
    province: "ایلام",
    cities: [
      {
        label: "ایلام",
        values: [
          {
            code: 98,
            letters: ["ب", "ج", "د"],
          },
        ],
      },
      {
        label: "مهران",
        values: [
          {
            code: 98,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "بدره",
        values: [
          {
            code: 98,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "دهلران",
        values: [
          {
            code: 98,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "چرداول",
        values: [
          {
            code: 98,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "ایوان",
        values: [
          {
            code: 98,
            letters: ["م"],
          },
        ],
      },
      {
        label: "ابدانان",
        values: [
          {
            code: 98,
            letters: ["ن"],
          },
        ],
      },
    ],
  },
  {
    province: "بوشهر",
    cities: [
      {
        label: "بوشهر",
        values: [
          {
            code: 48,
            letters: ["ب", "ج", "د", "س", "ص"],
          },
        ],
      },
      {
        label: "دشتستان",
        values: [
          {
            code: 58,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "گناوه",
        values: [
          {
            code: 58,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "کنگان",
        values: [
          {
            code: 58,
            letters: ["د", "ن"],
          },
        ],
      },
      {
        label: "تنگستان",
        values: [
          {
            code: 58,
            letters: ["س"],
          },
        ],
      },
      {
        label: "دشتی",
        values: [
          {
            code: 58,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "دیر",
        values: [
          {
            code: 58,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "دیلم",
        values: [
          {
            code: 58,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "جم",
        values: [
          {
            code: 58,
            letters: ["ل", "د", "ن"],
          },
        ],
      },
      {
        label: "عسلویه",
        values: [
          {
            code: 58,
            letters: ["د", "ن"],
          },
        ],
      },
    ],
  },
  {
    province: "تهران",
    cities: [
      {
        label: "تهران",
        values: [
          {
            code: 10,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 11,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 20,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 22,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 33,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 40,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 44,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 50,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 55,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 60,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 66,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 77,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 88,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 99,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
        ],
      },
      {
        label: "اسلام شهر",
        values: [
          {
            code: 21,
            letters: ["ب"],
          },
          {
            code: 30,
            letters: ["ص"],
          },
          {
            code: 38,
            letters: ["ق"],
          },
          {
            code: 78,
            letters: ["ب", "ی"],
          },
        ],
      },
      {
        label: "رباط کریم",
        values: [
          {
            code: 21,
            letters: ["ج", "ق"],
          },
          {
            code: 30,
            letters: ["ج", "و"],
          },
          {
            code: 38,
            letters: ["ل"],
          },
          {
            code: 78,
            letters: ["ج", "م"],
          },
        ],
      },
      {
        label: "بهارستان",
        values: [
          {
            code: 78,
            letters: ["ج", "م"],
          },
        ],
      },
      {
        label: "شهریار",
        values: [
          {
            code: 21,
            letters: ["د", "ط", "ل", "ه"],
          },
          {
            code: 30,
            letters: ["ب", "ق", "ن"],
          },
          {
            code: 38,
            letters: ["ج", "ط", "و"],
          },
          {
            code: 78,
            letters: ["د", "ه"],
          },
        ],
      },
      {
        label: "قدس",
        values: [
          {
            code: 78,
            letters: ["د", "ه"],
          },
        ],
      },
      {
        label: "ملارد",
        values: [
          {
            code: 78,
            letters: ["د", "ه"],
          },
        ],
      },
      {
        label: "ورامین",
        values: [
          {
            code: 21,
            letters: ["س", "م"],
          },
          {
            code: 30,
            letters: ["ط"],
          },
          {
            code: 38,
            letters: ["ص"],
          },
          {
            code: 78,
            letters: ["س"],
          },
        ],
      },
      {
        label: "پیشوا",
        values: [
          {
            code: 78,
            letters: ["س"],
          },
        ],
      },
      {
        label: "قرچک",
        values: [
          {
            code: 78,
            letters: ["س"],
          },
        ],
      },
      {
        label: "پاکدشت",
        values: [
          {
            code: 21,
            letters: ["ن"],
          },
          {
            code: 30,
            letters: ["ط"],
          },
          {
            code: 78,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "دماوند",
        values: [
          {
            code: 21,
            letters: ["ی"],
          },
          {
            code: 30,
            letters: ["ی", "ه"],
          },
          {
            code: 78,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "پردیس",
        values: [
          {
            code: 78,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "فیروزکوه",
        values: [
          {
            code: 78,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "ری",
        values: [
          {
            code: 78,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "شمیرانات",
        values: [
          {
            code: 78,
            letters: ["و"],
          },
        ],
      },
    ],
  },
  {
    province: "چهار محال و بختیاری",
    cities: [
      {
        label: "شهرکرد",
        values: [
          {
            code: 71,
            letters: ["ب", "ج", "د", "س", "ص"],
          },
        ],
      },
      {
        label: "بروجن",
        values: [
          {
            code: 81,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "اردل",
        values: [
          {
            code: 81,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "فارسان",
        values: [
          {
            code: 81,
            letters: ["د"],
          },
        ],
      },
      {
        label: "لردگان",
        values: [
          {
            code: 81,
            letters: ["س"],
          },
        ],
      },
      {
        label: "کوهرنگ",
        values: [
          {
            code: 81,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "بروجن",
        values: [
          {
            code: 81,
            letters: ["ق"],
          },
        ],
      },
    ],
  },
  {
    province: "خراسان شمالی",
    cities: [
      {
        label: "بجنورد",
        values: [
          {
            code: 32,
            letters: ["س"],
          },
          {
            code: 26,
            letters: ["ب", "ج", "د"],
          },
        ],
      },
      {
        label: "شیروان",
        values: [
          {
            code: 26,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "اسفراین",
        values: [
          {
            code: 26,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "جاجرم",
        values: [
          {
            code: 26,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "گرمه",
        values: [
          {
            code: 26,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "مانه و سملقان",
        values: [
          {
            code: 26,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "فاروج",
        values: [
          {
            code: 26,
            letters: ["م"],
          },
        ],
      },
      {
        label: "راز و جرگلان",
        values: [
          {
            code: 26,
            letters: ["ب", "ج", "د"],
          },
        ],
      },
    ],
  },
  {
    province: "خراسان رضوی",
    cities: [
      {
        label: "مشهد",
        values: [
          {
            code: 12,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 32,
            letters: ["و"],
          },
          {
            code: 36,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ه", "ی"],
          },
          {
            code: 42,
            letters: ["ج", "ق", "ه", "و"],
          },
          {
            code: 74,
            letters: ["ب", "د", "س", "ص", "ق", "م", "ن", "ه", "و", "ی"],
          },
        ],
      },
      {
        label: "نیشابور",
        values: [
          {
            code: 32,
            letters: ["ب", "ی"],
          },
          {
            code: 36,
            letters: ["ل"],
          },
          {
            code: 74,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "جٌوین",
        values: [
          {
            code: 32,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "خوشاب",
        values: [
          {
            code: 32,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "داورزن",
        values: [
          {
            code: 32,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "جٌغتای",
        values: [
          {
            code: 32,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "سبزوار",
        values: [
          {
            code: 32,
            letters: ["ج"],
          },
          {
            code: 36,
            letters: ["م"],
          },
          {
            code: 42,
            letters: ["ن"],
          },
          {
            code: 74,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "تربت ‌جام",
        values: [
          {
            code: 32,
            letters: ["ص"],
          },
          {
            code: 36,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "قوچان",
        values: [
          {
            code: 32,
            letters: ["ط"],
          },
          {
            code: 74,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "گناباد",
        values: [
          {
            code: 32,
            letters: ["ق"],
          },
          {
            code: 74,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "بجستان",
        values: [
          {
            code: 32,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "تربت‌ حیدریه",
        values: [
          {
            code: 32,
            letters: ["ل", "ن"],
          },
          {
            code: 36,
            letters: ["ن"],
          },
          {
            code: 42,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "مه ولات",
        values: [
          {
            code: 32,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "زاوه",
        values: [
          {
            code: 32,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "کاشمر",
        values: [
          {
            code: 32,
            letters: ["م"],
          },
          {
            code: 36,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "خلیل آباد",
        values: [
          {
            code: 32,
            letters: ["م"],
          },
        ],
      },
      {
        label: "تایباد",
        values: [
          {
            code: 32,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "فریمان",
        values: [
          {
            code: 42,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "سرخس",
        values: [
          {
            code: 42,
            letters: ["د"],
          },
        ],
      },
      {
        label: "درگز",
        values: [
          {
            code: 42,
            letters: ["س"],
          },
        ],
      },
      {
        label: "خواف",
        values: [
          {
            code: 42,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "چناران",
        values: [
          {
            code: 42,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "بردسکن",
        values: [
          {
            code: 42,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "رشتخوار",
        values: [
          {
            code: 42,
            letters: ["م"],
          },
        ],
      },
      {
        label: "کلات",
        values: [
          {
            code: 42,
            letters: ["ی"],
          },
        ],
      },
    ],
  },
  {
    province: "خراسان جنوبی",
    cities: [
      {
        label: "بیرجند",
        values: [
          {
            code: 32,
            letters: ["د"],
          },
          {
            code: 52,
            letters: ["ب", "ج", "د"],
          },
        ],
      },
      {
        label: "قائنات",
        values: [
          {
            code: 52,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "درمیان",
        values: [
          {
            code: 52,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "خوسف",
        values: [
          {
            code: 52,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "فردوس",
        values: [
          {
            code: 52,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "نهبندان",
        values: [
          {
            code: 52,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "سربیشه",
        values: [
          {
            code: 52,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "طبس",
        values: [
          {
            code: 64,
            letters: ["ق"],
          },
        ],
      },
    ],
  },
  {
    province: "خوزستان",
    cities: [
      {
        label: "اهواز",
        values: [
          {
            code: 14,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 34,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "آبادان",
        values: [
          {
            code: 24,
            letters: ["ب", "ق"],
          },
          {
            code: 34,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "خرمشهر",
        values: [
          {
            code: 24,
            letters: ["ج"],
          },
          {
            code: 34,
            letters: ["د"],
          },
        ],
      },
      {
        label: "دزفول",
        values: [
          {
            code: 24,
            letters: ["د"],
          },
          {
            code: 34,
            letters: ["ص", "و"],
          },
        ],
      },
      {
        label: "بهبهان",
        values: [
          {
            code: 24,
            letters: ["س"],
          },
          {
            code: 34,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "مسجد سلیمان",
        values: [
          {
            code: 24,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "ماهشهر",
        values: [
          {
            code: 24,
            letters: ["ط", "ه"],
          },
          {
            code: 34,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "دشت آزادگان",
        values: [
          {
            code: 24,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "رامهرمز",
        values: [
          {
            code: 24,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "اندیمشک",
        values: [
          {
            code: 24,
            letters: ["م"],
          },
          {
            code: 34,
            letters: ["س"],
          },
        ],
      },
      {
        label: "شوشتر",
        values: [
          {
            code: 24,
            letters: ["ن"],
          },
          {
            code: 34,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "شادگان",
        values: [
          {
            code: 24,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "شوش",
        values: [
          {
            code: 24,
            letters: ["و"],
          },
          {
            code: 34,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "ایذه",
        values: [
          {
            code: 24,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "باغملک",
        values: [
          {
            code: 34,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "امیدیه",
        values: [
          {
            code: 34,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "هندیجان",
        values: [
          {
            code: 34,
            letters: ["د"],
          },
        ],
      },
      {
        label: "لالی",
        values: [
          {
            code: 34,
            letters: ["س"],
          },
        ],
      },
    ],
  },
  {
    province: "زنجان",
    cities: [
      {
        label: "زنجان",
        values: [
          {
            code: 87,
            letters: ["ب", "د", "ج", "س", "ص", "ط"],
          },
        ],
      },
      {
        label: "ابهر",
        values: [
          {
            code: 97,
            letters: ["ب", "ق"],
          },
        ],
      },
      {
        label: "خدابنده",
        values: [
          {
            code: 97,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "خرم دره",
        values: [
          {
            code: 97,
            letters: ["د"],
          },
        ],
      },
      {
        label: "ایجرود",
        values: [
          {
            code: 97,
            letters: ["س"],
          },
        ],
      },
      {
        label: "طارم",
        values: [
          {
            code: 97,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "ماه نشان",
        values: [
          {
            code: 97,
            letters: ["ط"],
          },
        ],
      },
    ],
  },
  {
    province: "سمنان",
    cities: [
      {
        label: "سمنان",
        values: [
          {
            code: 86,
            letters: ["ب", "د", "ج"],
          },
        ],
      },
      {
        label: "دامغان",
        values: [
          {
            code: 96,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "شاهرود",
        values: [
          {
            code: 96,
            letters: ["ج", "ص", "ط"],
          },
        ],
      },
      {
        label: "گرمسار",
        values: [
          {
            code: 96,
            letters: ["د"],
          },
        ],
      },
      {
        label: "مهدی شهر",
        values: [
          {
            code: 96,
            letters: ["س"],
          },
        ],
      },
    ],
  },
  {
    province: "سیستان و بلوچستان",
    cities: [
      {
        label: "زاهدان",
        values: [
          {
            code: 85,
            letters: ["ب", "د", "ج", "س", "ص", "ط"],
          },
        ],
      },
      {
        label: "زابل",
        values: [
          {
            code: 95,
            letters: ["ب", "ل", "و"],
          },
        ],
      },
      {
        label: "ایرانشهر",
        values: [
          {
            code: 95,
            letters: ["ج", "م"],
          },
        ],
      },
      {
        label: "خاش",
        values: [
          {
            code: 95,
            letters: ["د"],
          },
        ],
      },
      {
        label: "سراوان",
        values: [
          {
            code: 95,
            letters: ["س", "ن"],
          },
        ],
      },
      {
        label: "نیکشهر",
        values: [
          {
            code: 95,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "سرباز",
        values: [
          {
            code: 95,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "چابهار",
        values: [
          {
            code: 95,
            letters: ["ق"],
          },
        ],
      },
    ],
  },
  {
    province: "فارس",
    cities: [
      {
        label: "شیراز",
        values: [
          {
            code: 63,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
              "ی",
            ],
          },
          {
            code: 83,
            letters: ["ج", "ص", "ط"],
          },
          {
            code: 93,
            letters: ["ج", "ص", "ط", "ب", "د", "س", "ق", "م", "ن", "و", "ی"],
          },
        ],
      },
      {
        label: "جهرم",
        values: [
          {
            code: 73,
            letters: ["ب"],
          },
          {
            code: 83,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "لارستان",
        values: [
          {
            code: 73,
            letters: ["ج"],
          },
          {
            code: 93,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "داراب",
        values: [
          {
            code: 73,
            letters: ["د"],
          },
          {
            code: 83,
            letters: ["س"],
          },
        ],
      },
      {
        label: "فسا",
        values: [
          {
            code: 73,
            letters: ["س"],
          },
          {
            code: 83,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "کازرون",
        values: [
          {
            code: 73,
            letters: ["ص"],
          },
          {
            code: 83,
            letters: ["ج", "ص", "ط", "ن"],
          },
          {
            code: 93,
            letters: ["و"],
          },
        ],
      },
      {
        label: "فیروز آباد",
        values: [
          {
            code: 73,
            letters: ["ط"],
          },
          {
            code: 83,
            letters: ["ج", "س", "ط"],
          },
          {
            code: 93,
            letters: ["و"],
          },
        ],
      },
      {
        label: "آباده",
        values: [
          {
            code: 73,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "مرودشت",
        values: [
          {
            code: 73,
            letters: ["ل"],
          },
          {
            code: 83,
            letters: ["ج", "ص", "ط", "و"],
          },
          {
            code: 93,
            letters: ["و"],
          },
        ],
      },
      {
        label: "لامرد",
        values: [
          {
            code: 73,
            letters: ["م"],
          },
        ],
      },
      {
        label: "نی ریز",
        values: [
          {
            code: 73,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "اقلید",
        values: [
          {
            code: 73,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "استهبان",
        values: [
          {
            code: 73,
            letters: ["و"],
          },
        ],
      },
      {
        label: "سپیدان",
        values: [
          {
            code: 73,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "ممسنی",
        values: [
          {
            code: 73,
            letters: ["ی"],
          },
          {
            code: 83,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "زرین‌دشت",
        values: [
          {
            code: 83,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "قیرکارزین",
        values: [
          {
            code: 83,
            letters: ["د"],
          },
        ],
      },
      {
        label: "مهر",
        values: [
          {
            code: 83,
            letters: ["س"],
          },
        ],
      },
      {
        label: "ارسنجان",
        values: [
          {
            code: 83,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "خرمبید",
        values: [
          {
            code: 83,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "آباده",
        values: [
          {
            code: 83,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "بوانات",
        values: [
          {
            code: 83,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "فراشبند",
        values: [
          {
            code: 83,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "لارستان",
        values: [
          {
            code: 83,
            letters: ["م"],
          },
        ],
      },
    ],
  },
  {
    province: "قزوین",
    cities: [
      {
        label: "قزوین",
        values: [
          {
            code: 79,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل", "م"],
          },
        ],
      },
      {
        label: "تاکستان",
        values: [
          {
            code: 89,
            letters: ["ب", "س"],
          },
        ],
      },
      {
        label: "بویین زهرا",
        values: [
          {
            code: 89,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "آبیک",
        values: [
          {
            code: 89,
            letters: ["د"],
          },
        ],
      },
    ],
  },
  {
    province: "قم",
    cities: [
      {
        label: "قم",
        values: [
          {
            code: 16,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "و",
              "ه",
            ],
          },
        ],
      },
    ],
  },
  {
    province: "کردستان",
    cities: [
      {
        label: "سنندج",
        values: [
          {
            code: 51,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل", "م", "ن", "و"],
          },
        ],
      },
      {
        label: "سقز",
        values: [
          {
            code: 61,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "بیجار",
        values: [
          {
            code: 61,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "بانه",
        values: [
          {
            code: 61,
            letters: ["د", "ه"],
          },
        ],
      },
      {
        label: "قروه",
        values: [
          {
            code: 61,
            letters: ["س", "ن"],
          },
        ],
      },
      {
        label: "مریوان",
        values: [
          {
            code: 61,
            letters: ["ص", "و"],
          },
        ],
      },
      {
        label: "دیواندره",
        values: [
          {
            code: 61,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "کامیاران",
        values: [
          {
            code: 61,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "سروآباد",
        values: [
          {
            code: 61,
            letters: ["ل"],
          },
        ],
      },
    ],
  },
  {
    province: "کرمان",
    cities: [
      {
        label: "کرمان",
        values: [
          {
            code: 45,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل", "م", "ن"],
          },
        ],
      },
      {
        label: "رفسنجان",
        values: [
          {
            code: 65,
            letters: ["ب", "ی"],
          },
          {
            code: 75,
            letters: ["س", "ل"],
          },
        ],
      },
      {
        label: "بم",
        values: [
          {
            code: 65,
            letters: ["ج"],
          },
          {
            code: 75,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "سیرجان",
        values: [
          {
            code: 65,
            letters: ["د"],
          },
          {
            code: 75,
            letters: ["ب", "ص", "م"],
          },
        ],
      },
      {
        label: "بافت",
        values: [
          {
            code: 65,
            letters: ["س"],
          },
        ],
      },
      {
        label: "جیرفت",
        values: [
          {
            code: 65,
            letters: ["ص"],
          },
          {
            code: 75,
            letters: ["د"],
          },
        ],
      },
      {
        label: "زرند",
        values: [
          {
            code: 65,
            letters: ["ط"],
          },
          {
            code: 75,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "کهنوج",
        values: [
          {
            code: 65,
            letters: ["ق"],
          },
          {
            code: 75,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "شهربابک",
        values: [
          {
            code: 65,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "بردسیر",
        values: [
          {
            code: 65,
            letters: ["م"],
          },
        ],
      },
      {
        label: "منوجان",
        values: [
          {
            code: 65,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "راور",
        values: [
          {
            code: 65,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "عنبرآباد",
        values: [
          {
            code: 65,
            letters: ["و"],
          },
        ],
      },
    ],
  },
  {
    province: "کرمانشاه",
    cities: [
      {
        label: "کرمانشاه",
        values: [
          {
            code: 19,
            letters: [
              "ب",
              "ج",
              "د",
              "س",
              "ص",
              "ط",
              "ق",
              "ل",
              "م",
              "ن",
              "ه",
              "و",
            ],
          },
        ],
      },
      {
        label: "اسلام‌آباد غرب",
        values: [
          {
            code: 29,
            letters: ["ب", "ه"],
          },
        ],
      },
      {
        label: "گیلان غرب",
        values: [
          {
            code: 29,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "سرپل ذهاب",
        values: [
          {
            code: 29,
            letters: ["د"],
          },
        ],
      },
      {
        label: "پاوه",
        values: [
          {
            code: 29,
            letters: ["س"],
          },
        ],
      },
      {
        label: "کنگاور",
        values: [
          {
            code: 29,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "قصرشیرین",
        values: [
          {
            code: 29,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "سنقر",
        values: [
          {
            code: 29,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "جوانرود",
        values: [
          {
            code: 29,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "صحنه",
        values: [
          {
            code: 29,
            letters: ["م"],
          },
        ],
      },
      {
        label: "هرسین",
        values: [
          {
            code: 29,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "ثلاث باباجانی",
        values: [
          {
            code: 29,
            letters: ["و"],
          },
        ],
      },
    ],
  },
  {
    province: "کهگیلویه و بویر احمد",
    cities: [
      {
        label: "یاسوج",
        values: [
          {
            code: 49,
            letters: ["ب", "ج", "د"],
          },
        ],
      },
      {
        label: "گچساران",
        values: [
          {
            code: 49,
            letters: ["ص", "ل"],
          },
        ],
      },
      {
        label: "کهگیلویه",
        values: [
          {
            code: 49,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "دنا",
        values: [
          {
            code: 49,
            letters: ["ق"],
          },
        ],
      },
    ],
  },
  {
    province: "گلستان",
    cities: [
      {
        label: "گلستان",
        values: [
          {
            code: 59,
            letters: ["ب", "ج", "د", "س", "ص"],
          },
        ],
      },
      {
        label: "گنبد کاووس",
        values: [
          {
            code: 69,
            letters: ["ب", "ه"],
          },
        ],
      },
      {
        label: "بندرترکمن",
        values: [
          {
            code: 69,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "کردکوی",
        values: [
          {
            code: 69,
            letters: ["د"],
          },
        ],
      },
      {
        label: "علی‌آباد",
        values: [
          {
            code: 69,
            letters: ["س"],
          },
        ],
      },
      {
        label: "آزادشهر",
        values: [
          {
            code: 69,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "مینودشت",
        values: [
          {
            code: 69,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "بندرگز",
        values: [
          {
            code: 69,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "رامیان",
        values: [
          {
            code: 69,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "آق قلا",
        values: [
          {
            code: 69,
            letters: ["م"],
          },
        ],
      },
      {
        label: "کلاله",
        values: [
          {
            code: 69,
            letters: ["ن"],
          },
        ],
      },
    ],
  },
  {
    province: "گیلان",
    cities: [
      {
        label: "رشت",
        values: [
          {
            code: 46,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل", "م", "ن", "و"],
          },
        ],
      },
      {
        label: "انزلی",
        values: [
          {
            code: 56,
            letters: ["ب"],
          },
          {
            code: 76,
            letters: ["س"],
          },
        ],
      },
      {
        label: "لاهیجان",
        values: [
          {
            code: 56,
            letters: ["ج"],
          },
          {
            code: 76,
            letters: ["د"],
          },
        ],
      },
      {
        label: "آستارا",
        values: [
          {
            code: 56,
            letters: ["د"],
          },
        ],
      },
      {
        label: "طالش",
        values: [
          {
            code: 56,
            letters: ["س"],
          },
          {
            code: 76,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "رودسر",
        values: [
          {
            code: 56,
            letters: ["ص"],
          },
          {
            code: 76,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "رودبار",
        values: [
          {
            code: 56,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "صومعه‌سرا",
        values: [
          {
            code: 56,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "فومن",
        values: [
          {
            code: 56,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "لنگرود",
        values: [
          {
            code: 56,
            letters: ["م"],
          },
          {
            code: 76,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "رضوانشهر",
        values: [
          {
            code: 56,
            letters: ["ن"],
          },
        ],
      },
      {
        label: "ماسال",
        values: [
          {
            code: 56,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "املش",
        values: [
          {
            code: 56,
            letters: ["و"],
          },
        ],
      },
      {
        label: "شفت",
        values: [
          {
            code: 56,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "سیاهکل",
        values: [
          {
            code: 76,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "آستانه",
        values: [
          {
            code: 76,
            letters: ["ج"],
          },
        ],
      },
    ],
  },
  {
    province: "لرستان",
    cities: [
      {
        label: "خرم آباد",
        values: [
          {
            code: 31,
            letters: ["ب", "ج", "د", "س", "ص"],
          },
        ],
      },
      {
        label: "بروجرد",
        values: [
          {
            code: 41,
            letters: ["ب", "م", "ن"],
          },
        ],
      },
      {
        label: "الیگودرز",
        values: [
          {
            code: 41,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "دورود",
        values: [
          {
            code: 41,
            letters: ["د", "و"],
          },
        ],
      },
      {
        label: "کوهدشت",
        values: [
          {
            code: 41,
            letters: ["س", "و"],
          },
        ],
      },
      {
        label: "دلفان",
        values: [
          {
            code: 41,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "ازنا",
        values: [
          {
            code: 41,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "پل دختر",
        values: [
          {
            code: 41,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "سلسله",
        values: [
          {
            code: 41,
            letters: ["ل"],
          },
        ],
      },
    ],
  },
  {
    province: "مازندران",
    cities: [
      {
        label: "ساری",
        values: [
          {
            code: 62,
            letters: ["ب", "ج", "د", "س", "ص", "ط"],
          },
        ],
      },
      {
        label: "آمل",
        values: [
          {
            code: 62,
            letters: ["ب"],
          },
          {
            code: 82,
            letters: ["د", "ق"],
          },
          {
            code: 92,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "بابل",
        values: [
          {
            code: 72,
            letters: ["ج"],
          },
          {
            code: 82,
            letters: ["ج", "ص", "م"],
          },
          {
            code: 92,
            letters: ["ج", "ص"],
          },
        ],
      },
      {
        label: "تنکابن",
        values: [
          {
            code: 72,
            letters: ["د"],
          },
          {
            code: 82,
            letters: ["ط"],
          },
          {
            code: 92,
            letters: ["د"],
          },
        ],
      },
      {
        label: "رامسر",
        values: [
          {
            code: 72,
            letters: ["س"],
          },
        ],
      },
      {
        label: "نوشهر",
        values: [
          {
            code: 72,
            letters: ["ص"],
          },
          {
            code: 82,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "نور",
        values: [
          {
            code: 72,
            letters: ["ط", "ی"],
          },
        ],
      },
      {
        label: "بهشهر",
        values: [
          {
            code: 72,
            letters: ["ق"],
          },
          {
            code: 82,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "قائمشهر",
        values: [
          {
            code: 72,
            letters: ["ل"],
          },
          {
            code: 82,
            letters: ["س", "ن"],
          },
          {
            code: 92,
            letters: ["س"],
          },
        ],
      },
      {
        label: "بابلسر",
        values: [
          {
            code: 72,
            letters: ["م"],
          },
          {
            code: 82,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "چالوس",
        values: [
          {
            code: 72,
            letters: ["ن"],
          },
          {
            code: 82,
            letters: ["و"],
          },
        ],
      },
      {
        label: "نکا",
        values: [
          {
            code: 72,
            letters: ["ه"],
          },
        ],
      },
      {
        label: "محمودآباد",
        values: [
          {
            code: 72,
            letters: ["و"],
          },
        ],
      },
      {
        label: "جویبار",
        values: [
          {
            code: 72,
            letters: ["ی"],
          },
        ],
      },
      {
        label: "سوادکوه",
        values: [
          {
            code: 82,
            letters: ["ب"],
          },
        ],
      },
    ],
  },
  {
    province: "مرکزی",
    cities: [
      {
        label: "اراک",
        values: [
          {
            code: 47,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق"],
          },
        ],
      },
      {
        label: "ساوه",
        values: [
          {
            code: 57,
            letters: ["ب", "ه", "و"],
          },
        ],
      },
      {
        label: "خمین",
        values: [
          {
            code: 57,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "محلات",
        values: [
          {
            code: 57,
            letters: ["د"],
          },
        ],
      },
      {
        label: "تفرش",
        values: [
          {
            code: 57,
            letters: ["س"],
          },
        ],
      },
      {
        label: "دلیجان",
        values: [
          {
            code: 57,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "آشتیان",
        values: [
          {
            code: 57,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "شازند",
        values: [
          {
            code: 57,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "زرندیه",
        values: [
          {
            code: 57,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "کمیجان",
        values: [
          {
            code: 57,
            letters: ["ن"],
          },
        ],
      },
    ],
  },
  {
    province: "هرمزگان",
    cities: [
      {
        label: "بندرعباس",
        values: [
          {
            code: 84,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل"],
          },
        ],
      },
      {
        label: "میناب",
        values: [
          {
            code: 94,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "بندر لنگه",
        values: [
          {
            code: 94,
            letters: ["ج", "ن"],
          },
        ],
      },
      {
        label: "رودان",
        values: [
          {
            code: 94,
            letters: ["د"],
          },
        ],
      },
      {
        label: "ابوموسی",
        values: [
          {
            code: 94,
            letters: ["س"],
          },
        ],
      },
      {
        label: "جاسک",
        values: [
          {
            code: 94,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "بستک",
        values: [
          {
            code: 94,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "حاجی‌آباد",
        values: [
          {
            code: 94,
            letters: ["ق"],
          },
        ],
      },
      {
        label: "قشم",
        values: [
          {
            code: 94,
            letters: ["ل"],
          },
        ],
      },
    ],
  },
  {
    province: "همدان",
    cities: [
      {
        label: "همدان",
        values: [
          {
            code: 18,
            letters: ["ب", "ج", "د", "س", "ص", "ق", "ل", "ط"],
          },
        ],
      },
      {
        label: "نهاوند",
        values: [
          {
            code: 28,
            letters: ["ب", "م"],
          },
        ],
      },
      {
        label: "ملایر",
        values: [
          {
            code: 28,
            letters: ["ج", "ل", "ن"],
          },
        ],
      },
      {
        label: "تویسرکان",
        values: [
          {
            code: 28,
            letters: ["د"],
          },
        ],
      },
      {
        label: "کبودرآهنگ",
        values: [
          {
            code: 28,
            letters: ["س"],
          },
        ],
      },
      {
        label: "رزن",
        values: [
          {
            code: 28,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "بهار",
        values: [
          {
            code: 28,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "اسدآباد",
        values: [
          {
            code: 28,
            letters: ["ق"],
          },
        ],
      },
    ],
  },
  {
    province: "یزد",
    cities: [
      {
        label: "یزد",
        values: [
          {
            code: 54,
            letters: ["ب", "ج", "د", "س", "ص", "ط", "ق", "ل", "م", "ن"],
          },
        ],
      },
      {
        label: "اردکان",
        values: [
          {
            code: 64,
            letters: ["ب"],
          },
        ],
      },
      {
        label: "تفت",
        values: [
          {
            code: 64,
            letters: ["ج"],
          },
        ],
      },
      {
        label: "میبد",
        values: [
          {
            code: 64,
            letters: ["د"],
          },
        ],
      },
      {
        label: "بافق",
        values: [
          {
            code: 64,
            letters: ["س"],
          },
        ],
      },
      {
        label: "مهریز",
        values: [
          {
            code: 64,
            letters: ["ص"],
          },
        ],
      },
      {
        label: "ابرکوه",
        values: [
          {
            code: 64,
            letters: ["ط"],
          },
        ],
      },
      {
        label: "خاتم",
        values: [
          {
            code: 64,
            letters: ["ل"],
          },
        ],
      },
      {
        label: "صدوق",
        values: [
          {
            code: 64,
            letters: ["م"],
          },
        ],
      },
    ],
  },
];

export const plateAlphabet = [
  "ب",
  "ج",
  "د",
  "س",
  "ل",
  "ق",
  "ص",
  "ط",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
  "الف (دولتی)",
  "پ (پلیس)",
  "ت (تاکسی)",
  "ث (سپاه)",
  "ز (وزارت دفاع)",
  "ش (ارتش)",
  "ع (عمومی)",
  "ف (نیروهای مسلح)",
  "ک (کشاورزی)",
  "گ (گذرموقت)",
  "ژ (معلولین)",
  "تشریفات",
  "D (سیاسی)",
  " (سیاسی) S",
];
